import styled from 'styled-components';
import { ReactComponent as ArrowDownIcon } from '@elementary/common-ui/assets/arrow-down-expand.svg';
import { Flex } from '@elementary/common-ui/components';
import { SxProps, Typography, Theme } from '@mui/material';

const ArrowDownIconStyled = styled(ArrowDownIcon)<{ $flip: boolean }>`
  transform: ${({ $flip }) => ($flip ? 'rotate(-180deg)' : undefined)};
  transition: transform 0.1s;
  path {
    fill: ${({ theme }) => theme.palette.icon.secondary};
  }
`;

const ShowMore = ({
  isExpanded,
  onClick,
  sx,
}: {
  isExpanded: boolean;
  onClick: () => void;
  sx?: SxProps<Theme>;
}) => (
  <Flex
    sx={{ alignItems: 'center', gap: 0.5, cursor: 'pointer', ...sx }}
    onClick={onClick}
  >
    <ArrowDownIconStyled width={12} $flip={isExpanded} />
    <Typography sx={{ color: 'content.secondary' }} noWrap>
      {`Show ${isExpanded ? 'less' : 'more'}`}
    </Typography>
  </Flex>
);

export default ShowMore;
